import React, { useEffect } from "react";
import TextField from "../../../../Forms/TextField";
import useAxios from "axios-hooks";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import DropDown from "../../../../Forms/DropDown";
import { Spinner, Checkbox } from "@fluentui/react";
import { Field, useFormikContext } from "formik";

const DescriptionFields = () => {
    const [{ data }] = useAxios('courses/levels');
    const [{ data: types, loadingSteps }] = useAxios(`courses/course-types`);
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        if (!values.incVideo) {
            setFieldValue("numVideoMinutes", null);
        }
    }, [values.incVideo, setFieldValue]);

    useEffect(() => {
        if (!values.incExAndGraph) {
            setFieldValue("numInteractiveExercises", null);
        }
    }, [values.incExAndGraph, setFieldValue]);

    if (loadingSteps)
        return <Spinner className="absolute-center" label="Loading..." />;

    return (
        <>
            <DropDown 
                label="Course Type" 
                name="crsCourseTypeId" 
                options={types && types.map(p => ({ key: p.crsCourseTypeId, text: p.name }))} 
                required={true} 
            />
            <ChoiceGroup 
                className="mt20" 
                label="Level" 
                name="crsLevelId" 
                options={data && data.map(level => ({ key: level.id, text: level.name }))} 
                required={true} 
            />
            <TextField 
                className="mt20" 
                label="Length (In Minutes)" 
                name="lengthMinutes" 
                required={true} 
            />
            <TextField 
                label="Short Description"  
                multiline 
                rows={3} 
                name="shortDescription" 
            />
            <TextField 
                label="Long Description" 
                multiline 
                rows={3} 
                name="longDescription" 
            />

            <TextField
                label="Minutes of Video"
                name="numVideoMinutes"
                type="number"
                min={0}
                max={32767}
            />

            <TextField
                label="# Interactive Exercises and Interactive Graphics"
                name="numInteractiveExercises"
                type="number"
                min={0}
                max={255}
            />

            <div className="mt20">
                <label className="mb5 block">What's Included</label>
                <Field type="checkbox" name="incVideo">
                    {({ field }) => (
                        <Checkbox className="mb5" label="Video(s)" {...field} checked={field.value} />
                    )}
                </Field>
                <Field type="checkbox" name="incExAndGraph">
                    {({ field }) => (
                        <Checkbox className="mb5" label="Interactive Exercises and/or Interactive Graphics" {...field} checked={field.value} />
                    )}
                </Field>
                <Field type="checkbox" name="incQuizzes">
                    {({ field }) => (
                        <Checkbox className="mb5" label="Quizzes" {...field} checked={field.value} />
                    )}
                </Field>
                <Field type="checkbox" name="incPersonalization">
                    {({ field }) => (
                        <Checkbox label="Personalization" {...field} checked={field.value} />
                    )}
                </Field>
            </div>
        </>
    );
};

export default DescriptionFields;
